<template>
  <div class="page_panel">
    <div class="confirm-panel">
      <el-switch
        v-model="commonParams.confirmFlag"
        active-color="#38D180"
        :active-value="1"
        :inactive-value="null"
        @change="initPageData()"
        inactive-color="#cccccc"
      ></el-switch>
      <span class="text">仅查看已确权数据</span>
    </div>
    <!-- 类型选择 -->
    <div class="filter-panel">
      <el-switch
        v-model="commonParams.isFilterVehicle"
        active-color="#915501"
        :active-value="true"
        :inactive-value="null"
        @change="filterTypeChange()"
        inactive-color="#cccccc"
      ></el-switch>
      <span class="text" style="margin-right: 10px">农机</span>
      <el-switch
        v-model="commonParams.isFilterUser"
        active-color="#499101"
        :active-value="true"
        :inactive-value="null"
        @change="filterTypeChange()"
        inactive-color="#cccccc"
      ></el-switch>
      <span class="text">机手</span>
    </div>
    <!-- 中间终端类型选择 -->
    <div class="drc_select" :class="getRightFold ? '' : 'right_fold_close'">
      <el-select
        v-model.trim="terminalType"
        placeholder=""
        class="work_select"
        popper-class="drc_select_popper"
      >
        <el-option
          v-for="item in terminalTypeSelectOptions"
          :key="item.dictValue"
          :label="item.dictLabel"
          :value="item.dictValue"
        ></el-option>
      </el-select>
    </div>
    <!-- 中间信息 -->
    <div class="center_panel">
      <div
        class="c_t_item"
        @click.stop.prevent="selectNum({ isCrossRegion: 1 }, 7)"
        :class="topSelectIndex == 7 ? 'active' : ''"
      >
        <div class="c_t_item_title">跨区数量 (台)</div>
        <div class="c_t_item_num">
          {{ headerStatics.crossRegionCount || 0 | numberSeparator }}
        </div>
        <img
          class="c_t_item_icon"
          :src="
            require(`../../assets/images/common/${
              topSelectIndex == 7 ? 'img_kuaqu_c' : 'img_kuaqu'
            }.png`)
          "
          alt=""
        />
      </div>
      <div class="c_t_item" @click.stop.prevent="selectNum({ isInArea: 1 }, 8)">
        <div class="c_t_item_title">入区数量 (台)</div>
        <div class="c_t_item_num">
          {{ headerStatics.inAreaCount || 0 | numberSeparator }}
        </div>
        <img
          class="c_t_item_icon"
          :src="
            require(`../../assets/images/common/${
              topSelectIndex == 8 ? 'img_kuaqu_c' : 'img_kuaqu'
            }.png`)
          "
          alt=""
        />
      </div>
    </div>
    <!-- 左侧 -->
    <div class="left_panel" :class="getLeftFold ? '' : 'left_fold_close'">
      <!-- 左上 -->
      <div class="l_top">
        <div
          class="l_t_item"
          @click.stop.prevent="selectNum({}, 0)"
          :class="topSelectIndex == 0 ? 'active' : ''"
        >
          <img
            class="l_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 0 ? 'icon_t1_c' : 'icon_t1'
              }.png`)
            "
            alt=""
          />
          <div class="l_t_item_title">农机总数 (台)</div>
          <div class="l_t_item_num">
            {{ (headerStatics.totalCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="l_t_item"
          @click.stop.prevent="selectNum({ isWork: 1 }, 22)"
          :class="topSelectIndex == 22 ? 'active' : ''"
        >
          <img
            class="l_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 22 ? 'icon_t3_c' : 'icon_t3'
              }.png`)
            "
            alt=""
          />
          <div class="l_t_item_title">正在作业 (台)</div>
          <div class="l_t_item_num">
            {{ (headerStatics.jobCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="l_t_item"
          @click.stop.prevent="selectNum({ isTodayWork: 1 }, 4)"
          :class="topSelectIndex == 4 ? 'active' : ''"
        >
          <img
            class="l_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 4 ? 'icon_t15_c' : 'icon_t15'
              }.png`)
            "
            alt=""
          />
          <div class="l_t_item_title">今日作业 (小时)</div>
          <div class="l_t_item_num">
            {{ (headerStatics.todayJobTime || 0) | numberSeparator }}
          </div>
        </div>
      </div>
      <!-- 左中 -->
      <div class="l_center">
        <Block :title="`${getLastAddreassName}各类型智能农机数量`">
          <vue-seamless-scroll
            :data="leftCenterList"
            class="seamless-warp"
            v-if="leftCenterList && leftCenterList.length > 0"
            :class-option="{ ...classOption, limitMoveNum: 4 }"
          >
            <div class="l_c_item" v-for="(v, i) in leftCenterList" :key="i">
              <div class="l_c_item_top">
                <div class="l_c_item_top_title">
                  {{
                    v.vehicleTypeCode == "01" || v.vehicleTypeCode == "04"
                      ? ""
                      : `No.${i + 1}`
                  }}
                  {{ v.vehicleTypeName || "--" }}
                </div>
                <div class="l_c_item_top_num">
                  <span>{{ (v.count || 0) | numberSeparator }}</span> 台
                </div>
              </div>
              <div class="l_c_item_slide_panel">
                <div
                  class="l_c_item_slide"
                  :class="{ orange: i == 0, yellow: i == 1, green: i > 1 }"
                  :style="{ width: `${leftCenterPer(v)}%` }"
                ></div>
              </div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <!-- 左下 -->
      <div class="l_bottom">
        <Block :title="`${getLastAddreassName}智能农机本市内跨区数量`">
          <div class="l_b_header">
            <div class="item">区域</div>
            <div class="item">农机数量</div>
            <div class="item"></div>
            <div class="item">数量占比</div>
          </div>
          <vue-seamless-scroll
            :data="leftBottomList"
            class="seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 4 }"
            v-if="leftBottomList && leftBottomList.length > 0"
          >
            <div class="l_b_item" v-for="(v, i) in leftBottomList" :key="i">
              <div class="item">{{ v.regionName || "--" }}</div>
              <div class="item">{{ (v.count || 0) | numberSeparator }}</div>
              <div class="item">
                <div
                  class="line"
                  :style="{ width: `${leftBottomPer(v)}%` }"
                ></div>
              </div>
              <div class="item">{{ leftBottomPer(v) }}%</div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <!-- 左下 -->
      <div class="l_bottom_last">
        <Block :title="`${getLastAddreassName}智能农机邻县区跨区数量`">
          <div class="l_b_header">
            <div class="item">区域</div>
            <div class="item">农机数量</div>
            <div class="item"></div>
            <div class="item">数量占比</div>
          </div>
          <vue-seamless-scroll
            :data="leftBottomLastList"
            class="seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 4 }"
            v-if="leftBottomLastList && leftBottomLastList.length > 0"
          >
            <div class="l_b_item" v-for="(v, i) in leftBottomLastList" :key="i">
              <div class="item">{{ v.regionName || "--" }}</div>
              <div class="item">{{ (v.count || 0) | numberSeparator }}</div>
              <div class="item">
                <div
                  class="line"
                  :style="{ width: `${leftBottomLastPer(v)}%` }"
                ></div>
              </div>
              <div class="item">{{ leftBottomLastPer(v) }}%</div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
    </div>
    <!--中间-->
    <div class="center-part">
      <div class="map_container">
        <map-model
          ref="mapModel"
          @townshipPoint="townshipPoint"
          @vehiclePointClick="vehiclePointClick"
          @userPointClick="userPointClick"
          :detailInfoShow.sync="detailInfoShow"
          :userDetailShow.sync="userDetailShow"
          :filterType="commonParams.filterType"
          :mapPointParmas="mapPointParmas"
          :commonParams="commonParams"
        ></map-model>
        <!-- <deviceMap></deviceMap> -->
      </div>
    </div>
    <!-- 右侧 -->
    <div class="right_panel" :class="getRightFold ? '' : 'right_fold_close'">
      <!-- 右上 -->
      <div class="r_top">
        <div
          class="r_t_item"
          @click.stop.prevent="selectNum({ isToday: 1 }, 3)"
          :class="topSelectIndex == 3 ? 'active' : ''"
        >
          <img
            class="r_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 3 ? 'icon_t4_c' : 'icon_t4'
              }.png`)
            "
            alt=""
          />
          <div class="r_t_item_title">今日上线 (台)</div>
          <div class="r_t_item_num">
            {{ (headerStatics.todayOnlineCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="r_t_item"
          @click.stop.prevent="selectNum({ isOnline: 1 }, 2)"
          :class="topSelectIndex == 2 ? 'active' : ''"
        >
          <img
            class="r_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 2 ? 'icon_t2_c' : 'icon_t2'
              }.png`)
            "
            alt=""
          />
          <div class="r_t_item_title">在线数量 (台)</div>
          <div class="r_t_item_num">
            {{ (headerStatics.onlineCount || 0) | numberSeparator }}
          </div>
        </div>
        <div
          class="r_t_item"
          @click.stop.prevent="selectNum({ isOnline: 0 }, 5)"
          :class="topSelectIndex == 5 ? 'active' : ''"
        >
          <img
            class="r_t_item_icon"
            :src="
              require(`../../assets/images/home/${
                topSelectIndex == 5 ? 'icon_t5_c' : 'icon_t5'
              }.png`)
            "
            alt=""
          />
          <div class="r_t_item_title">离线数量 (台)</div>
          <div class="r_t_item_num">
            {{ (headerStatics.offlineCount || 0) | numberSeparator }}
          </div>
        </div>
      </div>
      <!-- 右上图表 -->
      <div class="r_bottom_top">
        <Block :title="`${getLastAddreassName}月度智能农机上线数量`">
          <el-select
            v-model.trim="rightBottomTopMonth"
            placeholder=""
            class="work_select month_select"
          >
            <el-option
              v-for="item in monthOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <rightTopChart
            v-if="
              rightBottomTopData.regionProductionList &&
              rightBottomTopData.regionProductionList.length > 0
            "
            :chartData="rightBottomTopData"
          ></rightTopChart>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <!-- 右中图表 -->
      <div class="r_bottom_center">
        <Block :title="`${getLastAddreassName}智能农机实时上线情况`">
          <vue-seamless-scroll
            :data="rightBottomCenterList"
            class="seamless-warp"
            :class-option="{ ...classOption, limitMoveNum: 3 }"
            v-if="rightBottomCenterList && rightBottomCenterList.length > 0"
          >
            <div
              class="r_b_item"
              v-for="(v, i) in rightBottomCenterList"
              :key="i"
            >
              <div class="r_b_item_left">
                {{
                  v.reportingTime ? parseTime(v.reportingTime, "{m}-{d}") : "--"
                }}
                <br />
                {{
                  v.reportingTime
                    ? parseTime(v.reportingTime, "{h}:{i}:{s}")
                    : "--"
                }}
              </div>
              <div class="r_b_item_right">
                <div class="r_b_item_right_top">
                  IMEI号：{{ v.drcId || "--" }}
                </div>
                <div class="r_b_item_right_bottom">
                  上线地址：{{ v.currAddress || v.address || "--" }}
                </div>
              </div>
            </div>
          </vue-seamless-scroll>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
      <!-- 右下图表 -->
      <div class="r_bottom_bottom">
        <Block :title="`${getLastAddreassName}年度智能农机上线数量`">
          <el-select
            v-model.trim="rightBottomBYear"
            placeholder=""
            class="work_select month_select"
          >
            <el-option
              v-for="item in yearOptions"
              :key="item.text"
              :label="item.text"
              :value="item.text"
            ></el-option>
          </el-select>
          <rightBottomChart
            v-if="
              rightBottomBData.regionProductionList &&
              rightBottomBData.regionProductionList.length > 0
            "
            :chartData="rightBottomBData"
          ></rightBottomChart>
          <div v-else class="empty_panel"></div>
        </Block>
      </div>
    </div>
    <Modal
      :show="townshipDialog"
      :title="townshipInfo.pointName + '农业机械购置量'"
      width="11vw"
      :showColse="false"
      class="township-dialog"
      :setStyle="getTownshipStyle"
    >
      <div slot="content" class="modal-content" style="padding: 10px 0px">
        <div v-html="townshipInfo.description"></div>
      </div>
    </Modal>
    <Modal
      :show="userDetailShow"
      title="机手详情"
      width="36vw"
      @close="userDetailShow = false"
    >
      <div slot="content" class="modal-content" style="padding: 10px 0px">
        <div class="info-detail-item">
          <div class="label">姓名：</div>
          <div class="value">{{ userDetail.userName || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">手机号：</div>
          <div class="value">{{ userDetail.phone || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">当前位置：</div>
          <div class="value">{{ userDetail.address || "--" }}</div>
        </div>
        <div class="info-title">名下农机</div>
        <div class="dialog-user-info_list">
          <div class="user-info_list--header">
            <div class="user-info_list--header__item" style="flex: 1.3">
              地盘/机架号
            </div>
            <div class="user-info_list--header__item">车牌号</div>
            <div class="user-info_list--header__item">品牌</div>
            <div class="user-info_list--header__item" style="flex: 1.5">
              品类
            </div>
            <div class="user-info_list--header__item" style="flex: 1.3">
              喂入量(Kg/s)
            </div>
            <div class="user-info_list--header__item">轮式/履带</div>
          </div>
          <div class="user-info_list--content">
            <template
              v-if="
                userDetail.userVehicleList &&
                userDetail.userVehicleList.length > 0
              "
            >
              <div
                class="user-info_list--tr"
                v-for="(item, i) in userDetail.userVehicleList"
                :key="i"
              >
                <div class="user-info_list--td" style="flex: 1.3">
                  {{ item.wholeVehicleNumber || "--" }}
                </div>
                <div class="user-info_list--td">
                  {{ item.vehicleCard || "--" }}
                </div>
                <div class="user-info_list--td">
                  {{ item.brandName || "--" }}
                </div>
                <div class="user-info_list--td" style="flex: 1.5">
                  {{ item.vehicleTypeName || "--" }}
                </div>
                <div class="user-info_list--td" style="flex: 1.3">
                  {{ item.feedAmount || "--" }}
                </div>
                <div class="user-info_list--td">
                  {{
                    item.wheelType == 0
                      ? "轮式"
                      : item.wheelType == 1
                      ? "履带"
                      : "--"
                  }}
                </div>
              </div>
            </template>
            <div class="user-info_list--tr notdata" v-else>
              <div class="user-info_list--td empty_panel"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" slot="footer">
        <el-button type="warning" size="medium" @click="userDetailShow = false"
          >确定</el-button
        >
      </div>
    </Modal>
    <Modal
      :show="detailInfoShow"
      title="农机信息"
      width="30vw"
      @close="detailInfoShow = false"
    >
      <div slot="content" class="modal-content" style="padding: 10px 15px">
        <div class="info-detail-item">
          <div class="label">车牌号：</div>
          <div class="value">{{ detailInfo.vehicleCard || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">底盘/机架号：</div>
          <div class="value">{{ detailInfo.wholeVehicleNumber || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">车辆品牌：</div>
          <div class="value">{{ displayValue(detailInfo.brandName) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">车辆品类：</div>
          <div class="value">{{ displayValue(detailInfo.vehicleTypeName) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">车辆型号：</div>
          <div class="value">{{ displayValue(detailInfo.vehicleModuleName) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">喂入量：</div>
          <div class="value">{{ displayWithUnit(detailInfo.feedAmount, 'kg/s') }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">轮式/履带：</div>
          <div class="value">{{ wheelTypeText(detailInfo.wheelType) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">主机制造商：</div>
          <div class="value">{{ displayValue(detailInfo.makerName) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">发动机编号：</div>
          <div class="value">{{ detailInfo.engineId || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">车辆归属：</div>
          <div class="value">{{ displayValue(detailInfo.owner) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">归属组织机构代码：</div>
          <div class="value">{{ detailInfo.idCard || "--" }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">归属地址：</div>
          <div class="value">{{ displayValue(detailInfo.address) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">联系方式：</div>
          <div class="value">{{ displayValue(detailInfo.phone) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">归属类型：</div>
          <div class="value">{{ displayValue(detailInfo.ownerType) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">驾驶员：</div>
          <div class="value">{{ displayValue(detailInfo.driver) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">驾驶员手机号：</div>
          <div class="value">{{ displayValue(detailInfo.driverPhone) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">最后定位时间：</div>
          <div class="value">{{ displayValue(detailInfo.reportingTime) }}</div>
        </div>
        <div class="info-detail-item">
          <div class="label">车辆当前位置：</div>
          <div class="value">{{ displayValue(detailInfo.currAddress) }}</div>
        </div>
        <template v-if="detailInfo.jobTerminalInfo && detailInfo.jobTerminalInfo.length">
          <div v-for="(terminal, index) in detailInfo.jobTerminalInfo" :key="'job-' + index">
            <div class="info-title">作业终端信息</div>
            <div class="info-detail-item"><div class="label">终端供应商：</div><div class="value">{{ displayValue(terminal.makerName) }}</div></div>
            <div class="info-detail-item"><div class="label">终端序列号：</div><div class="value">{{ displayValue(terminal.drcId) }}</div></div>
            <div class="info-detail-group">
              <div class="info-detail-item"><div class="label">当日作业量：</div><div class="value">{{ displayWithUnit(terminal.todayArea, '亩') }}</div></div>
              <div class="info-detail-item"><div class="label">累计作业量：</div><div class="value">{{ displayWithUnit(terminal.allArea, '亩') }}</div></div>
            </div>
          </div>
        </template>
        <template v-if="detailInfo.positionTerminalInfos && detailInfo.positionTerminalInfos.length">
          <div v-for="(terminal, index) in detailInfo.positionTerminalInfos" :key="'position-' + index">
            <div class="info-title">定位终端信息</div>
            <div class="info-detail-item"><div class="label">终端供应商：</div><div class="value">{{ displayValue(terminal.makerName) }}</div></div>
            <div class="info-detail-item"><div class="label">终端序列号：</div><div class="value">{{ displayValue(terminal.drcId) }}</div></div>
            <div class="info-detail-group">
              <div class="info-detail-item"><div class="label">当年开机时长：</div><div class="value">{{ displayWithUnit(terminal.duration, '小时') }}</div></div>
              <div class="info-detail-item"><div class="label">当年驾驶里程：</div><div class="value">{{ displayWithUnit(terminal.distance, '千米') }}</div></div>
            </div>
            <div class="info-detail-group">
              <div class="info-detail-item"><div class="label">累计开机时长：</div><div class="value">{{ displayWithUnit(terminal.totalDuration, '小时') }}</div></div>
              <div class="info-detail-item"><div class="label">累计驾驶里程：</div><div class="value">{{ displayWithUnit(terminal.totalDistance, '千米') }}</div></div>
            </div>
          </div>
        </template>
        <template v-if="detailInfo.ziJiaYiTerminalInfo && detailInfo.ziJiaYiTerminalInfo.length">
          <div v-for="(terminal, index) in detailInfo.ziJiaYiTerminalInfo" :key="'drive-' + index">
            <div class="info-title">自驾仪信息</div>
            <div class="info-detail-item"><div class="label">终端供应商：</div><div class="value">{{ displayValue(terminal.makerName) }}</div></div>
            <div class="info-detail-item"><div class="label">终端序列号：</div><div class="value">{{ displayValue(terminal.drcId) }}</div></div>
          </div>
        </template>
        <div class="vehicle-track-button-box" v-if="detailInfo.kind == 1">
          <div @click="showVehicleTrackDialog(detailInfo)" class="button">
            {{ detailInfo && detailInfo.isOnline ? "实时轨迹" : "历史轨迹" }}
          </div>
        </div>
      </div>
    </Modal>
    <VehicleTrackDialog
      :visible="vehicleTrackDialogVisible"
      :item="detailInfo"
      @close="vehicleTrackDialogVisible = false"
    />
    <JobTypeSelect
      v-model="currentVehicleTypeCodes"
      :options="jobTypeList"
      @change="selectJobType"
    />
  </div>
</template>

<script>
import VehicleTrackDialog from "@/components/track/index.vue";
import cityMap from "./components/homeMap";
import mapModel from "./components/mapModel";
import deviceMap from "./../components/deviceMap/index.vue";
import homePolyline from "@components/chart/polyline";
import rightBottomChart from "./components/right_bottom_chart.vue";
import rightTopChart from "./components/right_top_chart.vue";
import * as homeApi from "@/api/home";
import * as commonApi from "@/api/common";
import { mapGetters } from "vuex";
import Modal from "@components/modal.vue";
import JobTypeSelect from "@components/jobTypeSelect";
import Block from "@components/block";
import iconMap from "@/utils/iconType";
import { parseTime } from "@/utils/index";

export default {
  components: {
    VehicleTrackDialog,
    JobTypeSelect,
    mapModel,
    cityMap,
    homePolyline,
    rightTopChart,
    rightBottomChart,
    deviceMap,
    Modal,
    Block,
  },
  computed: {
    ...mapGetters([
      "getactiveRegionObj",
      "getLeftFold",
      "getRightFold",
      "getLastAddreassName",
    ]),
    getTownshipStyle() {
      return {
        left: (this.townshipInfo.x - 120 || 0) + "px",
        top: (this.townshipInfo.y + 80 || 0) + "px",
      };
    },
    // 本县农机设施数量-没项数据占比百分比计算
    leftCenterPer() {
      return (data) => {
        return (
          (Number(data.count) == 0
            ? 0
            : Number(data.count) / Number(this.leftCenterTotal)) * 100
        ); // 百分比
      };
    },
    // 智能农机本市内跨区数量-没项数据占比百分比计算
    leftBottomPer() {
      return (data) => {
        return (
          Number(data.count) == 0
            ? 0
            : (Number(data.count) / Number(this.leftBottomTotal)) * 100
        ).toFixed(2); // 百分比
      };
    },
    // 智能农机邻县区跨区数量-没项数据占比百分比计算
    leftBottomLastPer() {
      return (data) => {
        return (
          Number(data.count) == 0
            ? 0
            : (Number(data.count) / Number(this.leftBottomLastTotal)) * 100
        ).toFixed(2); // 百分比
      };
    },
    // 滚动设置
    classOption() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
    mapPointParmas() {
      return {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.topSelectData,
        ...this.commonParams,
      };
    },
  },
  data() {
    return {
      currentVehicle: null,
      vehicleTrackDialogVisible: false,
      // 公共筛选条件，initPageData调用的所有api，都包含该参数
      commonParams: {
        confirmFlag: null,
        filterType: 0,
        isFilterUser: true,
        isFilterVehicle: true,
      },
      userDetailShow: false,
      userDetail: {},
      parseTime,
      // 地图点击终端类型1作业2定位
      terminalTypePoint: null,
      // 终端类型选择
      terminalType: 0,
      // 终端类型下拉
      terminalTypeSelectOptions: [
        // {
        //   terminalId: 0,
        //   terminalName: '全部',
        // },
        // {
        //   terminalId: 1,
        //   terminalName: '作业终端',
        // },
        // {
        //   terminalId: 2,
        //   terminalName: '定位终端',
        // }
      ],
      // 作业类型选择
      currentVehicleTypeCodes: null,
      // 农机信息
      detailInfo: {},
      // 农机信息是否展示
      detailInfoShow: false,
      vehicleDetailRequestSerial: 0,
      // 车辆状态筛选数据
      topSelectData: {},
      // 顶部统计数据
      headerStatics: {
        isJobNumber: 0,
        crossRegionCount: 0,
        todayOnlineNumber: 0,
        vehicleNumber: 0,
        vehicleNumberNotOnline: 0,
        vehicleNumberOnline: 0,
      },
      // 本县农机设施数量-总
      leftCenterTotal: 0,
      // 本县农机设施数量-数据
      leftCenterList: [],
      // 本县农机设施数量-总
      leftBottomTotal: 0,
      // 智能农机本市内跨区数量
      leftBottomList: [],
      // 本县农机设施数量-总
      leftBottomLastTotal: 0,
      // 智能农机邻县区跨区数量
      leftBottomLastList: [],
      // 右上图表月份
      rightBottomTopMonth: new Date().getMonth() + 1,
      // 右上图表数据
      rightBottomTopData: {
        regionProductionList: [],
        legends: [],
      },
      // 右下图表年份
      rightBottomBYear: new Date().getFullYear(),
      // 右下图表数据
      rightBottomBData: {
        regionProductionList: [],
        legends: [],
      },
      // 农机实时上线情况数据
      rightBottomCenterList: [],
      // 作业类型数据
      jobTypeList: [],
      // 作业类型图标枚举
      iconMap,
      topSelectIndex: 0,
      // 乡镇统计显示
      townshipDialog: false,
      // 乡镇统计信息
      townshipInfo: {},
      // 年份下拉
      yearOptions: [],
      // 月份下拉
      monthOptions: [
        { value: 1, label: "1月" },
        { value: 2, label: "2月" },
        { value: 3, label: "3月" },
        { value: 4, label: "4月" },
        { value: 5, label: "5月" },
        { value: 6, label: "6月" },
        { value: 7, label: "7月" },
        { value: 8, label: "8月" },
        { value: 9, label: "9月" },
        { value: 10, label: "10月" },
        { value: 11, label: "11月" },
        { value: 12, label: "12月" },
      ],
      userList: [],
      vehicleList: [],
    };
  },
  watch: {
    /** 路由监听 处理左右bg图变化 */
    $route: {
      handler(route) {
        if (
          route.path == "/" ||
          route.path == "/home" ||
          route.path == "/home/"
        )
          this.setTimer();
        else {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
      },
      deep: true,
    },
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        const city = "city_" + val.areaCode;
        this.$nextTick(() => {
          if (this.$refs.mapModel) {
            this.$refs.mapModel.addProvince(city);
            this.getJobTypeList();
            this.getTownPointList();
          }
        });
      },
    },
    // 本县农机设施数量总量
    leftCenterList: {
      handler(val) {
        this.leftCenterTotal = 0;
        val.map((v) => {
          this.leftCenterTotal += Number(v.count);
        });
      },
      deep: true,
      immediate: true,
    },
    // 本市其他县区终端安装农机数量总量
    leftBottomList: {
      handler(val = []) {
        this.leftBottomTotal = 0;
        val.map((v) => {
          this.leftBottomTotal += Number(v.count);
        });
      },
      deep: true,
      immediate: true,
    },
    // 本市其他县区终端安装农机数量总量
    leftBottomLastList: {
      handler(val = []) {
        this.leftBottomLastTotal = 0;
        val.map((v) => {
          this.leftBottomLastTotal += Number(v.count);
        });
      },
      deep: true,
      immediate: true,
    },
    // 终端类型
    terminalType: {
      handler(val) {
        this.getJobTypeList();
        this.initPageData();
      },
    },
    // 右上月份变更
    rightBottomTopMonth: {
      handler(val) {
        // 月度智能农机上线数量
        this.getOnLineCountByMonth();
      },
    },
    // 右下年份变更
    rightBottomBYear: {
      handler(val) {
        // 年度智能农机上线数量
        this.getOnlineListByType();
      },
    },
  },
  name: "Home",
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === '' ? '--' : String(value);
    },
    displayWithUnit(value, unit) {
      return value === null || value === undefined || value === '' ? '--' : `${value}${unit}`;
    },
    wheelTypeText(value) {
      if (String(value) === '0') return '轮式';
      if (String(value) === '1') return '履带';
      return '--';
    },
    /**收割机按区域聚合农机、机手数量 */
    getAreaCount() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.topSelectData,
        ...this.commonParams,
      };
      homeApi.getAreaCount(params).then((res) => {
        this.$refs.mapModel.resetAreaCount(res || []);
      });
    },
    // 大屏农机分布终端类型下拉列表
    getTrminalTypeSelectOptions() {
      homeApi.getDictData("home_terminal_type_select_options").then((res) => {
        this.terminalTypeSelectOptions = res || [];
      });
    },
    // 获取终端类型默认展示值
    getLargeScreenHomeTerminalType() {
      homeApi.getDictData("large_screen_home_terminal_type").then((res) => {
        let list = res || [];
        let findData =
          list && list.length > 0
            ? list.find((v) => {
                return v.dictLabel == this.getactiveRegionObj.areaCode;
              })
            : null;
        this.terminalType =
          findData && findData.dictValue ? findData.dictValue : "0";
      });
    },
    showVehicleTrackDialog(item) {
      console.log("正在进入农机轨迹", item);
      let self = this;
      self.currentVehicle = item;
      self.vehicleTrackDialogVisible = true;
    },
    filterTypeChange() {
      if (this.commonParams.isFilterVehicle && this.commonParams.isFilterUser) {
        // 全部
        this.commonParams.filterType = 0;
        this.$refs.mapModel.setVehiclePoints(
          this.vehicleList.concat(this.userList) || []
        );
      } else if (
        this.commonParams.isFilterVehicle &&
        !this.commonParams.isFilterUser
      ) {
        // 车辆
        this.commonParams.filterType = 1;
        this.$refs.mapModel.setVehiclePoints(this.vehicleList || []);
      } else if (
        this.commonParams.isFilterUser &&
        !this.commonParams.isFilterVehicle
      ) {
        // 人机
        this.commonParams.filterType = 2;
        this.$refs.mapModel.setVehiclePoints(this.userList || []);
      } else {
        // 空
        this.commonParams.filterType = -1;
        this.$refs.mapModel.setVehiclePoints([]);
      }
    },
    /** 查询乡镇信息及点位列表 */
    getTownPointList() {
      commonApi.getTownPointList({ belong: 1 }).then((res) => {
        this.$refs.mapModel.setTownship(res);
      });
    },
    /** 乡镇统计交互 */
    townshipPoint(isShow, info) {
      this.townshipDialog = isShow;
      this.townshipInfo = info || {};
    },
    selectNum(data, item) {
      this.topSelectData = data;
      this.topSelectIndex = item;
      this.point();
    },
    /** 计时器 */
    setTimer() {
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.initPageData();
      }, 1000 * 60);
    },
    /** 初始化 */
    initPageData() {
      // 本县农机设施数量
      this.getDrcCountByType();
      // 智能农机邻县区跨区数量
      this.getCrossRegionNeighborCount();
      // 智能农机本市内跨区数量
      this.getCrossRegionInAreaCount();
      // 农机实时上线情况
      this.getOnlineList();
      // 左上数据获取
      this.getVehicleNumber();
      // 车辆信息
      this.point();
      // 年度智能农机上线数量
      this.getOnlineListByType();
      // 月度智能农机上线数量
      this.getOnLineCountByMonth();
    },
    userPointClick(e) {
      const params = { userId: e._userId };
      homeApi.getUserVehicleInfo(params).then((res) => {
        this.userDetail = res;
        this.userDetailShow = true;
      });
    },
    /** 获取车辆 */
    point() {
      this.getAreaCount();
      return;
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.topSelectData,
        ...this.commonParams,
      };
      homeApi.point(params).then((res) => {
        homeApi.getUserAndVehiclePointList(params).then((userRes) => {
          // 人机
          if (userRes.userPointList && userRes.userPointList.length > 0) {
            let effectivePoint = userRes.userPointList.filter((v) => {
              return (
                v.latitude &&
                v.longitude &&
                0 < v.longitude &&
                v.longitude <= 180 &&
                0 < v.latitude &&
                v.latitude <= 90
              );
            });
            this.userList = effectivePoint;
          } else {
            this.userList = [];
          }
          // 车辆
          if (res && res.length > 0) {
            this.vehicleList = res || [];
          } else {
            this.vehicleList = [];
          }
          if (this.commonParams.filterType == 0) {
            // 全部
            this.$refs.mapModel.setVehiclePoints(
              this.vehicleList.concat(this.userList) || []
            );
          } else if (this.commonParams.filterType == 1) {
            // 车辆
            this.$refs.mapModel.setVehiclePoints(this.vehicleList || []);
          } else if (this.commonParams.filterType == 2) {
            // 人机
            this.$refs.mapModel.setVehiclePoints(this.userList || []);
          } else {
            // 空
            this.$refs.mapModel.setVehiclePoints([]);
          }
        });
      });
    },
    /** 车辆点击 */
    vehiclePointClick(item) {
      this.getVehicleInfo(item);
    },
    getVehicleInfo(item) {
      const vehicleId = item && (item.vehicleId || item._vehicleId);
      if (!vehicleId) return;
      const requestSerial = this.vehicleDetailRequestSerial + 1;
      this.vehicleDetailRequestSerial = requestSerial;
      const params = { vehicleId };
      homeApi.getVehicleInfoByVehicleId(params).then((res) => {
        if (requestSerial !== this.vehicleDetailRequestSerial) return;
        const detail = res || {};
        const registerInfo = detail.yunxingRegisterVehicleDto;
        if (registerInfo) {
          detail.wholeVehicleNumber = registerInfo.wholeVehicleNumber;
          detail.owner = registerInfo.owner;
          detail.phone = registerInfo.ownerPhone;
          detail.feedAmount = registerInfo.feedAmount;
          detail.wheelType = registerInfo.wheelType;
          detail.brandName = registerInfo.brandName;
          detail.vehicleCard = registerInfo.vehicleCard;
        }
        this.detailInfo = {
          ...detail,
          vehicleId: detail.vehicleId || vehicleId,
          kind: detail.kind === null || detail.kind === undefined ? 1 : detail.kind,
          isOnline: item.isOnline !== undefined ? item.isOnline : item._isOnline,
        };
        this.detailInfoShow = true;
      });
    },
    /** 农机详情获取 */
    getVehicleInfoByDrcId(drcId, terminalType) {
      const params = { drcId: drcId, type: terminalType };
      homeApi.getVehicleInfoByDrcId(params).then((res) => {
        // 判断是否存在登记信息、是否强关联
        if (res && res.yunxingRegisterVehicleDto) {
          // 存在登记信息
          res.wholeVehicleNumber =
            res.yunxingRegisterVehicleDto.wholeVehicleNumber;
          res.owner = res.yunxingRegisterVehicleDto.owner;
          res.phone = res.yunxingRegisterVehicleDto.ownerPhone;
          res.feedAmount = res.yunxingRegisterVehicleDto.feedAmount;
          res.wheelType = res.yunxingRegisterVehicleDto.wheelType;
          res.brandName = res.yunxingRegisterVehicleDto.brandName;
          res.vehicleCard = res.yunxingRegisterVehicleDto.vehicleCard;
          res.vehicleTypeName = "谷物联合收割机"; // 登记的默认:谷物联合收割机
        } else if (res.bindStatus < 2) {
          // 非强关联,设置默认:--
          // 0-未绑定，1-弱绑定，2-强绑定
          res.owner = "--";
          res.idCard = "--";
          res.address = "--";
          res.phone = "--";
          res.ownerType = "--";
        }
        this.detailInfo = res || {};
        this.detailInfoShow = true;
      });
    },
    /** 年度智能农机上线数量 */
    getOnlineListByType() {
      homeApi
        .getOnlineListByType({
          vehicleTypeCode: this.currentVehicleTypeCodes,
          type: this.terminalType,
          viewYear: this.rightBottomBYear,
          ...this.commonParams,
        })
        .then((res) => {
          let arr = res.filter((v) => {
            return (
              v.vehicleType &&
              v.vehicleType != 255 &&
              v.vehicleType != 0 &&
              v.vehicleType != "01" &&
              v.vehicleType != "04"
            );
          });
          // 0、255
          let otherArr = res.filter((v) => {
            return (
              v.vehicleType == 0 ||
              v.vehicleType == 255 ||
              v.vehicleType == null ||
              v.vehicleType == undefined
            );
          });
          // 定位终端
          let siteArr = res.filter((v) => {
            return v.vehicleType == "01" || v.vehicleType == "04";
          });
          // 其他分类（0、255）
          let otherObj = {
            datas: [],
            vehicleType: null,
            vehicleTypeId: null,
            vehicleTypeName: "其他",
          };
          otherArr.map((v) => {
            if (otherObj.datas.length <= 0)
              otherObj.datas = v.datas.map((vv) => {
                return { dates: vv.dates, onlineSum: 0 };
              });
            otherObj.datas.map((item, index) => {
              item.onlineSum += Number(v.datas[index].onlineSum);
            });
          });
          let newArr = [otherObj].concat(arr);
          if (siteArr && siteArr.length > 0) {
            arr = siteArr.concat(arr);
            newArr = siteArr.concat(newArr);
          }
          let dataList = otherArr && otherArr.length > 0 ? newArr : arr;
          let legends = dataList.map((item) => {
            return item.vehicleTypeName;
          });
          this.rightBottomBData.regionProductionList = dataList;
          this.rightBottomBData.legends = legends;
          this.$forceUpdate();
        });
    },
    /** 月度智能农机上线数量 */
    getOnLineCountByMonth() {
      homeApi
        .getOnLineCountByMonth({
          vehicleTypeCode: this.currentVehicleTypeCodes,
          type: this.terminalType,
          viewMonth: this.rightBottomTopMonth,
          ...this.commonParams,
        })
        .then((res = []) => {
          let arr = res.filter((v) => {
            return (
              v.vehicleType &&
              v.vehicleType != 255 &&
              v.vehicleType != 0 &&
              v.vehicleType != "01" &&
              v.vehicleType != "04"
            );
          });
          // 0、255
          let otherArr = res.filter((v) => {
            return (
              v.vehicleType == 0 ||
              v.vehicleType == 255 ||
              v.vehicleType == null ||
              v.vehicleType == undefined
            );
          });
          // 定位终端
          let siteArr = res.filter((v) => {
            return v.vehicleType == "01" || v.vehicleType == "04";
          });
          // 其他分类（0、255）
          let otherObj = {
            datas: [],
            vehicleType: null,
            vehicleTypeId: null,
            vehicleTypeName: "其他农机",
          };
          otherArr.map((v) => {
            if (otherObj.datas.length <= 0)
              otherObj.datas = v.datas.map((vv) => {
                return { dates: vv.dates, onlineSum: 0 };
              });
            otherObj.datas.map((item, index) => {
              item.onlineSum += Number(v.datas[index].onlineSum);
            });
          });
          let newArr = [otherObj].concat(arr);
          if (siteArr && siteArr.length > 0) {
            arr = siteArr.concat(arr);
            newArr = siteArr.concat(newArr);
          }
          let dataList = otherArr && otherArr.length > 0 ? newArr : arr;
          let legends = dataList.map((item) => {
            return item.vehicleTypeName;
          });
          this.rightBottomTopData.regionProductionList = dataList;
          this.rightBottomTopData.legends = legends;
          this.$forceUpdate();
        });
    },
    // 本县农机设施数量
    getDrcCountByType() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.commonParams,
      };
      homeApi.getDrcCountByType(params).then((res) => {
        let arr = res.filter((v) => {
          return (
            v.vehicleTypeCode &&
            // v.vehicleTypeCode != 255 &&
            v.vehicleTypeCode != "01" &&
            v.vehicleTypeCode != "04"
          );
        });
        arr.sort((v, vv) => vv.count - v.count); // 排序
        // 0、255
        // let otherArr = res.filter(v=>{return (v.vehicleTypeCode == 0 || v.vehicleTypeCode == 255 || v.vehicleTypeCode == null || v.vehicleTypeCode == undefined) });
        // 定位终端
        let siteArr = res.filter((v) => {
          return v.vehicleTypeCode == "01" || v.vehicleTypeCode == "04";
        });
        // 其他分类（0、255）
        // let otherObj = {
        //   count: 0,
        //   vehicleTypeCode:null,
        //   vehicleTypeId: null,
        //   vehicleTypeName: '其他农机'
        // };
        // otherArr.map(v=>{otherObj.count+=(v.count)});
        // let newArr = arr.concat([otherObj]);
        if (siteArr && siteArr.length > 0) {
          arr = arr.concat(siteArr);
          // newArr = newArr.concat(siteArr);
        }
        // if(otherArr && otherArr.length>0) {
        //   this.leftCenterList = newArr;
        // } else
        this.leftCenterList = arr;
      });
    },
    /** 本市内跨区数量 */
    getCrossRegionInAreaCount() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.commonParams,
      };
      homeApi.getCrossRegionInAreaCount(params).then((res) => {
        this.leftBottomList = res || [];
      });
    },
    /** 邻县区跨区数量 */
    getCrossRegionNeighborCount() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.commonParams,
      };
      homeApi.getCrossRegionNeighborCount(params).then((res) => {
        this.leftBottomLastList = res || [];
      });
    },
    /** 农机实时上线情况 */
    getOnlineList() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.commonParams,
      };
      homeApi.getOnlineList(params).then((res) => {
        this.rightBottomCenterList = res || [];
      });
    },
    /** 左上数据获取 */
    getVehicleNumber() {
      let params = {
        vehicleTypeCode: this.currentVehicleTypeCodes,
        type: this.terminalType,
        ...this.commonParams,
      };
      homeApi.getVehicleNumber(params).then((res) => {
        this.headerStatics = Object.assign(this.headerStatics, res);
      });
    },
    /** 选择作业类型 */
    selectJobType(e) {
      this.currentVehicleTypeCodes = e.jobTypeCode;
      this.setTimer();
      this.initPageData();
    },
    /** 获取作业类型 */
    getJobTypeList() {
      homeApi
        .getVehicleType({ type: this.terminalType, ...this.topSelectData })
        .then((res) => {
          res = res.map((v) => {
            v.icon = this.iconMap[String(v.vehicleTypeCode)]
              ? this.iconMap[String(v.vehicleTypeCode)].jobIcon
              : this.iconMap["default"].jobIcon;
            v.iconActive = this.iconMap[String(v.vehicleTypeCode)]
              ? this.iconMap[String(v.vehicleTypeCode)].jobIconActive
              : this.iconMap["default"].jobIconActive;
            return {
              icon: v.icon,
              iconActive: v.iconActive,
              jobTypeCode: v.vehicleTypeCode,
              jobTypeName:
                v.vehicleTypeName == "其他收获作业"
                  ? "其他农机"
                  : v.vehicleTypeName,
            };
          });
          res.unshift({
            jobTypeCode: undefined,
            jobTypeName: "全部",
            icon: this.iconMap["default"].jobIcon,
            iconActive: this.iconMap["default"].jobIconActive,
          });
          this.jobTypeList = res;
        });
    },
  },
  mounted() {
    for (let index = 0; index < new Date().getFullYear() - 2021; index++) {
      const year = 2022 + index;
      this.yearOptions.push({
        text: year,
      });
    }
    this.getTrminalTypeSelectOptions();
    this.getLargeScreenHomeTerminalType();
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  },
  created() {},
};
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.page_panel {
  width: 100%;
  height: vh(920);
  display: flex;
  margin-top: -6vh;
  position: relative;
}
.info-detail-item {
  display: flex;
  line-height: vh(24);
  align-items: flex-start;
  margin-bottom: 6px;
  .label {
    width: vw(124);
    color: #e9f0f7;
    text-align: right;
    font-size: fontSize(12);
    white-space: nowrap;
  }
  .value {
    color: #0dffa9;
    flex: 1;
    font-size: fontSize(12);
    display: flex;
  }
}
.info-title {
  margin: vh(5) vw(0);
  color: #ffff9a;
  font-size: fontSize(14);
  font-weight: 400;
}
.info-detail-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  .info-detail-item {
    width: 50%;
  }
}
.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: vh(1080);
  float: right;
}
::v-deep.filter-panel {
  position: absolute;
  top: vh(122);
  right: vw(490);
  width: vw(184);
  z-index: 9;
  box-shadow: 0px 0px 4px 0px #999999;
  background: rgba(12, 76, 36, 0.7);
  border-radius: 4px;
  padding: vh(6) vw(8);
  display: flex;
  align-items: center;
  .el-switch {
    margin-right: 8px;
  }
  .text {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: fontSize(14);
    color: #fff;
    line-height: 10px;
  }
}
.confirm-panel {
  background: rgba(12, 76, 36, 0.7);
  box-shadow: 0px 0px 4px 0px #999999;
  border-radius: 4px;
  position: absolute;
  top: vh(80);
  right: vw(498);
  width: vw(176);
  z-index: 999;
  padding: vh(6) vw(8);
  display: flex;
  align-items: center;
  justify-content: center;
  .el-switch {
    margin-right: 8px;
  }
  .text {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: fontSize(14);
    color: #fff;
    line-height: 10px;
  }
}
::v-deep.drc_select {
  width: vw(144);
  height: vh(41);
  background: url("../../assets/images/common/bg_zd.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 9;
  top: vh(29);
  right: vw(529);
  display: flex;
  align-items: center;
  padding: vh(4) 0 0 0;
  transition: all 300ms;
  &:before {
    content: "";
    position: absolute;
    width: vw(16);
    height: vh(17);
    background: url("../../assets/images/common/icon_zd.png") no-repeat;
    background-size: 100% 100%;
    left: vw(19);
  }
  .work_select {
    padding: 0 vw(10) 0 0;
    .el-input__inner {
      padding: 0 vw(10) 0 vw(38);
      text-align: center;
    }
  }
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}
// 左侧样式
::v-deep.left_panel,
::v-deep.right_panel {
  width: vw(390);
  z-index: 100;
  padding-left: vw(24);
  display: flex;
  flex-direction: column;
  position: relative;
  // 左上
  .l_top,
  .r_top {
    height: vh(160);
    display: flex;
    padding-bottom: vh(0);
    flex-shrink: 0;
    .l_t_item,
    .r_t_item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-left: vw(16);
      padding-top: vh(16);
      cursor: pointer;
      &_icon {
        width: vw(56);
        height: vh(47);
      }
      &_title {
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: vh(32);
      }
      &_num {
        font-size: fontSize(24);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0dffa9;
        padding-top: vh(0.5);
      }
      &.active {
        .l_t_item_num,
        .r_t_item_num {
          color: #ffae0d;
        }
      }
    }
  }
  // 左中
  .l_center {
    flex: 1;
    box-sizing: border-box;
    padding-bottom: vh(10);
    .b_container,
    .seamless-warp {
      overflow: hidden;
      height: vh(187);
    }
    .l_c_item {
      height: vh(50);
      display: flex;
      flex-direction: column;
      padding-right: vw(44);
      padding-left: vw(11);
      justify-content: center;
      &_top {
        display: flex;
        align-items: center;
        &_title {
          flex: 1;
          font-size: fontSize(14);
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
        &_num {
          font-size: fontSize(14);
          font-family: Microsoft YaHei;
          color: #ffffff;
          span {
            color: #0dffa9;
            font-weight: bold;
          }
        }
      }
      &_slide_panel {
        height: vh(4);
        background: #034b21;
        border-radius: vw(2);
        margin-top: vh(8);
        display: flex;
        align-items: center;
        .l_c_item_slide {
          height: 100%;
          border-radius: vw(2);
          position: relative;
          display: flex;
          align-items: center;
          &:before {
            content: "";
            position: absolute;
            right: 0;
            width: vw(6.1);
            height: vw(6.1);
            background: #ffffff;
            border-radius: 50%;
          }
          &.orange {
            background: linear-gradient(90deg, #e8a725 0%, #e2d36a 100%);
            &:before {
              box-shadow: 0 0 5px 2px #e2d36a, 0 0 25px 2px #e2d36a,
                0 0 50px 2px #e2d36a, 0 0 200px 2px #e2d36a;
            }
          }
          &.yellow {
            background: linear-gradient(90deg, #e8e825 0%, #e0f58a 100%);
            &:before {
              box-shadow: 0 0 5px 2px #e0f58a, 0 0 25px 2px #e0f58a,
                0 0 50px 2px #e0f58a, 0 0 200px 2px #e0f58a;
            }
          }
          &.green {
            background: linear-gradient(
              90deg,
              rgba(13, 255, 169, 0.3) 0%,
              #0dffa9 100%
            );
            &:before {
              box-shadow: 0 0 5px 2px #0dffa9, 0 0 25px 2px #0dffa9,
                0 0 50px 2px #0dffa9, 0 0 200px 2px #0dffa9;
            }
          }
        }
      }
    }
  }
  // 左下、左下左后一项
  .l_bottom {
    margin-bottom: vh(10);
  }
  .l_bottom,
  .l_bottom_last {
    flex-shrink: 0;
    height: vh(250);
    padding-right: vw(40);
    display: flex;
    flex-direction: column;
    .b_container,
    .seamless-warp {
      overflow: hidden;
    }
    .l_b_header,
    .l_b_item {
      height: vh(42);
      line-height: vh(42);
      display: flex;
      margin-left: vw(6);
      margin-right: vw(20);
      .item {
        flex: 1;
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        padding-right: vw(12);
        &:last-child {
          text-align: right;
          padding-right: vw(14);
        }
      }
    }
    .l_b_item {
      height: vh(41);
      line-height: vh(41);
      &:nth-of-type(odd) {
        height: vh(35);
        line-height: vh(35);
        background-color: rgba(13, 255, 169, 0.25);
      }
      .item {
        flex: 1;
        text-align: center;
        padding-right: vw(12);
        &:nth-of-type(3) {
          display: flex;
          align-items: center;
          position: relative;
          &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: vh(7);
            background-color: #034b21;
            z-index: 1;
          }
          .line {
            position: absolute;
            height: vh(7);
            background-color: #0dffa9;
            z-index: 2;
          }
        }
      }
    }
  }
}
// 右侧样式
::v-deep.right_panel {
  padding-left: vw(0);
  padding-right: vw(24);
  position: absolute;
  right: 0;
  height: 100%;
  .r_top {
    .r_t_item {
      padding-left: vw(0);
      padding-right: vw(24);
    }
  }
  .r_bottom_top {
    height: vh(220);
    padding-left: vw(10);
    padding-bottom: vw(10);
    .month_select {
      position: absolute;
      top: vh(5);
      right: vw(5);
    }
  }
  .r_bottom_bottom {
    flex: 1;
    padding-left: vw(40);
    .month_select {
      position: absolute;
      width: vw(80);
      top: vh(5);
      right: vw(5);
      .el-input__inner {
        padding: 0 vw(0) 0 vw(16);
      }
    }
  }
  .r_bottom_center {
    height: vh(269);
    padding-left: vw(40);
    .b_container,
    .seamless-warp {
      overflow: hidden;
      padding: vh(0) vh(6) vh(16) vh(6);
    }
    .r_b_item {
      height: vw(66);
      margin-bottom: vh(6);
      display: flex;
      &_left {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: vw(66);
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        border: 1px solid;
        border-right: none;
        border-image: linear-gradient(0deg, #074824, #07612f) 10 10;
        background: linear-gradient(
          0deg,
          rgba(14, 201, 136, 0.65) 0%,
          rgba(13, 255, 169, 0.65) 50%,
          rgba(14, 201, 136, 0.65) 100%
        );
      }
      &_right {
        line-height: vw(18.5);
        flex: 1;
        padding: vh(5) vw(10) 0 vw(10);
        font-size: fontSize(14);
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        border: 1px solid;
        border-left: none;
        border-image: linear-gradient(0deg, #074824, #07612f) 10 10;
        background: linear-gradient(
          0deg,
          rgba(6, 84, 57, 0.25) 0%,
          rgba(13, 255, 169, 0.25) 50%,
          rgba(14, 201, 136, 0.25) 100%
        );
      }
    }
  }
}

::v-deep.township-dialog {
  .modal-container {
    position: fixed;
    // width: vw(230) !important;
    padding: 0;
    top: 0;
    left: 0;
    transform: translateX() none;
    border-radius: 0;
    .modal-content {
      padding: 0 0px;
      .info-detail-title {
        color: #e9f0f7;
        text-align: left;
        font-size: fontSize(14);
        padding-top: 10px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0px;
          right: 0px;
          height: 1px;
          background-color: #009915;
          top: 2px;
        }
        &:first-child {
          padding-top: 0;
          &:before {
            content: none;
          }
        }
      }
      .info-detail-item {
        .label {
          width: vw(100);
          text-align: left;
        }
      }
    }
  }
}
.left_panel {
  left: 0;
  transition: all 300ms;
  &.left_fold_close {
    left: -100%;
    transition: all 300ms;
  }
}
.right_panel {
  right: 0;
  transition: all 300ms;
  &.right_fold_close {
    right: -100%;
    transition: all 300ms;
  }
}
.center_panel {
  width: vw(270);
  height: vh(79);
  position: absolute;
  z-index: 9;
  top: vh(95);
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  background: url("../../assets/images/common/bg_kuaqu.png") no-repeat;
  background-size: 100% 100%;
  .c_t_item {
    flex: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding-bottom: vh(16);
    &_title {
      font-size: fontSize(14);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    &_num {
      font-size: fontSize(24);
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
    &_icon {
      position: absolute;
      z-index: -1;
      bottom: vh(4);
      width: vw(106);
      height: vw(43);
    }
  }
}
.dialog-user-info_list {
  width: 100%;
  .user-info_list--header {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #c4ffe1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #00a756;
    &__item {
      padding-left: 16px;
      flex: 1;
      text-align: left;
      padding: 4px 0px 4px 16px;
      line-height: 20px;
    }
  }
  .user-info_list--content {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #c4ffe1;
    width: 100%;
    .user-info_list--tr {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid #008846;
      .user-info_list--td {
        padding: 4px 0px 4px 16px;
        flex: 1;
        text-align: left;
        line-height: 20px;
        word-break: break-all;
      }
      &.notdata {
        .user-info_list--td {
          padding: 4px 16px 4px 16px;
          text-align: center;
          height: 50px;
          &::before {
            font-size: 40px;
          }
        }
      }
    }
  }
}
</style>
